import { FC } from "react"
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";


interface IClientTypesDropDown{
    selectedClientType: number|null;
    isLoading: boolean;
    clientTypes: any[];
    updateParentState: (obj: object) => void;
}

export const ClientTypesDropDown: FC<IClientTypesDropDown> = ({
    selectedClientType,
    isLoading,
    clientTypes,
    updateParentState
}) => {

    return(
        <FormControl
        style={{minWidth: '12rem',boxSizing: 'border-box',flexGrow: 1, padding: "0.5rem 0"}}
        fullWidth
        variant="outlined"
        size="small"
      >
        <InputLabel htmlFor="typeLabel" >
          Client Type
        </InputLabel>
        {!!selectedClientType && <Select
          disabled={isLoading}
          labelId="clientTypeLabel"
          id="client-type"
          value={selectedClientType}
          onChange={({ target: { value } }) => {
            updateParentState({
              selectedClientType: Number(value),
              clientTypeChanged: true
            })}}
        >
          {clientTypes.map((type) => {
              return (
                <MenuItem key={type.clientTypeId} value={type.clientTypeId}>
                  {type.name}
                </MenuItem>
              );
            })}
        </Select>}
      </FormControl>
    )
}